import { TRAVELERS_HIDDEN_INPUT_TYPE } from "components/shared/TravelersField";
import { HotelWizardState } from "stores/wizard/state";
import { useConfigOverrides } from "stores/wizard/config/overrideConfigByView/useConfigOverrides";

export const useHotwireHotelOverrides = (hotelWizardState: HotelWizardState) =>
  useConfigOverrides(hotelWizardState, () => {
    const { date, location, travelers, form } = hotelWizardState.config;

    date.maxDaysRange = 30;
    date.daysBookableInAdvance = 330;
    date.defaultOffsetDates = {
      start: 0,
      end: 1,
    };

    location.destination.labelToken = "hotwire.wizard.hotel.destination.label";
    location.destination.queryParams = {
      regionId: "",
      latLong: "",
      iataCode: "",
      countryCode: "",
    };

    const baseToken = "hotwire.wizard.roomPicker";

    travelers.labelToken = `${baseToken}.travelers.title`;
    travelers.dialogTitleToken = `${baseToken}.travelers.title`;
    travelers.singleTravelerToken = `${baseToken}.singleTraveler`;
    travelers.multipleTravelersToken = `${baseToken}.multipleTravelers`;
    travelers.singleRoomSingleGuestToken = `${baseToken}.singleRoomSingleGuest`;
    travelers.singleRoomMultipleGuestsToken = `${baseToken}.singleRoomMultipleGuests`;
    travelers.multipleRoomsMultipleGuestsToken = `${baseToken}.multipleRoomsMultipleGuests`;
    travelers.maxTravelersPerRoom = 4;
    travelers.maxBookableTravelers = 24;
    travelers.maxAdultsPerRoom = 4;
    travelers.maxChildrenPerRoom = 3;
    travelers.maxRooms = 6;
    travelers.hiddenInputType = TRAVELERS_HIDDEN_INPUT_TYPE.HOTWIRE_HOTEL_SEARCH;
    travelers.withAges = false;
    travelers.withInfants = false;

    form.action = "https://www.hotwire.com/hotels/search";
    form.submitButton.locToken = "hotwire.wizard.hotel.submit";
  });
